import React, { useEffect, useState } from 'react'
import { Space, Table, Modal, Flex } from 'antd';
import { useGwGoodsGuigeListQuery, } from '../../store/ReactWebSiteApi';
import WebGoodsSpecEdit from './WebGoodsSpecEdit';
import WebGoodsSpecDel from './WebGoodsSpecDel';
import { DownCircleOutlined } from '@ant-design/icons';
import WebGoodsSpecAdd from './WebGoodsSpecAdd';
function WebGoodsSpecList(props) {
    const [open, setOpen] = useState(false);
    const {data,isSuccess} = useGwGoodsGuigeListQuery({eowgg_eowg_id:props.eowg_id},{skip:!open,refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eowgg_id:key,eowgg_eowg_id,eowgg_eowg_name,eowgg_name,eowgg_uname,eowgg_ctime,eowgg_jiage,eowgg_image} = item;
                    return item = {key,eowgg_eowg_id,eowgg_eowg_name,eowgg_name,eowgg_uname,eowgg_ctime,eowgg_jiage,eowgg_image}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                        let aTimeString = a.eowgg_serial_number;
                        let bTimeString = b.eowgg_serial_number;
                        return aTimeString - bTimeString;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [                                       
        {
            key: 'eowgg_name',
            title: '规格名称',
            dataIndex:'eowgg_name', 
           
        },            
        {
            key: 'eowgg_jiage',
            title: '价格',
            dataIndex:'eowgg_jiage', 
        },                                          
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        }, 
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>{record.eowgg_ctime + record.eowgg_uname}</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <WebGoodsSpecEdit
                            eowgg_id={record.key}
                            eowgg_eowg_id={record.eowgg_eowg_id}
                        />
                        <WebGoodsSpecDel
                            eowgg_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]
    return (
        <>
            <a onClick={() => {setOpen(true)}}><DownCircleOutlined /> 规格</a>
            <Modal
                open={open}
                title={`规格(${props.eowg_name})`}
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {}}
                width={800}
            >
                <Flex justify='flex-end'>
                    <WebGoodsSpecAdd
                        eowg_id={props.eowg_id}
                        eowg_name={props.eowg_name}
                    />
                </Flex>
                <Table columns={columns} dataSource={list}></Table>  
            </Modal>
        </>
    )
}

export default WebGoodsSpecList